"use client";

import { useState } from "react";
import { Link, Shield, SlidersHorizontal, Trophy, Zap } from "lucide-react";
import styles from "./Roles.module.css";

import rolesData from "../../data/roles-home.json";


const integrations = [
    "VivaReal",
    "ZAP Imóveis",
    "OLX",
    "Chaves na Mão",
    "Porto Seguro",
    "PJ Bank",
    "Nexxera",
    "TBanks",
    "RD Station",
    "Exact Sales",
    "Contratos Digitais",
    "LAIS",
    "SI Corretora",
    "CredAluga",
];

export default function Roles() {
    const roles = rolesData.roles || [];
    const [activeRoleId, setActiveRoleId] = useState("");

    if (!roles.length) return null;

    return (
        <>
            <section className={styles.whySection}>
                <div className={styles.whyBlock}>
                    <p className={styles.whyEyebrow}>Por que a Flexpro</p>
                    <h2 className={styles.whyTitle}>Números que falam por si</h2>
                    <p className={styles.whySubtitle}>
                        Resultado real de imobiliárias que adotaram o ecossistema completo
                    </p>
                </div>

                <div className={styles.bentoGrid}>
                    <div className={`${styles.bentoCard} ${styles.satisfactionCard}`}>
                        <span className={styles.darkIcon}>
                            <Trophy size={22} />
                        </span>
                        <strong className={styles.bigMetric}>93%</strong>
                        <h3>Taxa de satisfação</h3>
                        <p>dos clientes avaliam que o sistema transformou a operação da imobiliária</p>
                    </div>

                    <div className={`${styles.bentoCard} ${styles.implementationCard}`}>
                        <span className={styles.lightIcon}>
                            <Zap size={22} />
                        </span>
                        <h3>Implementação ágil e dedicada</h3>
                        <p>Nosso processo de onboarding guiado coloca sua equipe operando o sistema com agilidade, com treinamento, migração de dados e suporte dedicado.</p>
                    </div>

                    <div className={`${styles.bentoCard} ${styles.reworkCard}`}>
                        <span className={styles.blueIcon}>
                            <SlidersHorizontal size={22} />
                        </span>
                        <h3>Flexibilidade</h3>
                        <p>Sua imobiliária, seu jeito de operar. Você define como a sua operação funciona ajustando e adicionando funcionalidades de acordo com seu momento.</p>
                    </div>

                    <div className={styles.bentoCard}>
                        <span className={styles.lightIcon}>
                            <Link size={22} />
                        </span>
                        <h3>+13 integrações que sustentam a operação</h3>
                        <p>Chaves na Mão, LAIS IA, OLX, Porto Seguro, van bancária, Scaza, Facebook e WhatsApp, configurados por nós para facilitar sua operação.</p>
                    </div>

                    <div className={styles.bentoCard}>
                        <span className={styles.lightIcon}>
                            <Shield size={22} />
                        </span>
                        <h3>Segurança e conformidade</h3>
                        <p>LGPD, backups automáticos, registro de alterações e permissões por perfil para toda a sua equipe.</p>
                    </div>
                </div>
            </section>

            <section className={styles.roles}>
                <div className={styles.container}>
                <div className={styles.titleSection}>
                    <p className={styles.eyebrow}>Por perfil</p>
                    <h2 className={styles.title}>
                        Cada área da sua imobiliária tem o que precisa
                    </h2>
                    <p className={styles.subtitle}>
                        Diferentes perfis, necessidades específicas. A Flexpro foi construída para cada um deles.
                    </p>
                </div>

                <div className={styles.roleCards}>
                    {roles.map((role) => {
                        const isActive = activeRoleId === role.id;

                        return (
                            <button
                                key={role.id}
                                className={`${styles.roleCard} ${isActive ? styles.activeRoleCard : ""}`}
                                onClick={() => setActiveRoleId(isActive ? "" : role.id)}
                                type="button"
                                aria-expanded={isActive}
                            >
                                <span className={styles.roleCardHeader}>
                                    <span className={styles.roleCardTitle}>
                                        {role.title}
                                    </span>
                                    <span className={styles.toggleIcon} aria-hidden="true">
                                        {isActive ? "−" : "+"}
                                    </span>
                                </span>

                                {isActive && (
                                    <span className={styles.roleCardBody}>
                                        <span className={styles.roleDescription}>
                                            {role.description}
                                        </span>
                                        <span className={styles.benefits}>
                                            {role.benefits.map((benefit, index) => (
                                                <span key={index} className={styles.benefitItem}>
                                                    {benefit}
                                                </span>
                                            ))}
                                        </span>
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
                </div>
            </section>

            <section className={styles.integrationsSection}>
                <div className={styles.integrationsContainer}>
                    <p className={styles.integrationsEyebrow}>Integrações</p>
                    <h2 className={styles.integrationsTitle}>Conectado ao ecossistema imobiliário</h2>
                    <p className={styles.integrationsSubtitle}>
                        +13 integrações nativas com portais, bancos, seguradoras e ferramentas de marketing
                    </p>

                    <div className={styles.integrationPills}>
                        {integrations.map((integration) => (
                            <span key={integration} className={styles.integrationPill}>
                                <span aria-hidden="true" />
                                {integration}
                            </span>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
